<template>
  <nav class="sidebar d-flex flex-column main-menu-com" id="sidebar">
    <ul class="admin-nav" role="tablist">
      <li class="admin-nav-item">
        <a href="#admin_studios" @click.stop.prevent="selectTab('#admin_studios')">
          <span class="item">{{ $t('studios') }}</span>
        </a>
      </li>
      <li class="admin-nav-item" v-if="fit20.user.email == 'mohammaddarwesh@fit20.com'">
        <a href="#admin_machines" @click.stop.prevent="selectTab('#admin_machines')">
          <span class="item">{{ $t('machines') }}</span>
        </a>
      </li>
      <li class="admin-nav-item">
        <a href="#admin_trainers" @click.stop.prevent="selectTab('#admin_users')">
          <span class="item">{{ $t('users') }}</span>
        </a>
      </li>
      <li class="admin-nav-item">
        <a href="#admin_members" @click.stop.prevent="selectTab('#admin_members')">
          <span class="item">{{ $t('members') }}</span>
        </a>
      </li>
      <!-- <li class="admin-nav-item">
        <a href="#admin_overviews"  id="overviews-tab" @click.stop.prevent="selectTab('#admin_overviews')">
          <span class="item">{{ $t('M0043') }}</span>
        </a>
      </li> -->
    </ul>
  </nav>
</template>


<script>
export default {
  name: 'MainMenu',
  props: ["user", "selectTab", "admin_fit20", "fit20"],
  data() {
    return {};
  },
  methods: {
  },
  computed: {
    memberSince: function () { },
  },
};
</script>

<style>
.main-menu-com .admin-nav {
  width: 100%;
  padding-top: 20px;
}

.main-menu-com .admin-nav li {
  width: 100%;
  text-align: center;
  padding: 10px 15px;
}

.main-menu-com .admin-nav li a {
  padding: 5px 15px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  border: solid 1px #009EFB;
  border-radius: 10px;
  z-index: 999;
}
</style>
